export default __webpack_public_path__ + "static/media/alert.e2e956ce.mp3";